import React, { useState } from "react";

// You can swap these for imports if you have a central constants file.
const GENDERS = ["MALE", "FEMALE", "NON_BINARY", "OTHER"];
const ETHNICITIES = [
  "WHITE",
  "BLACK",
  "ASIAN",
  "HISPANIC",
  "NATIVE_AMERICAN",
  "PACIFIC_ISLANDER",
  "OTHER",
];

export default function PersonalInfoEditModal({ initial, onClose, onSave }) {
  const [form, setForm] = useState({
    firstName: initial?.firstName || "",
    lastName: initial?.lastName || "",
    dateOfBirth: initial?.dateOfBirth || "", // YYYY-MM-DD
    email: initial?.email || "",
    phoneNumber: initial?.phoneNumber || "",
    gender: initial?.gender || "",
    ethnicity: initial?.ethnicity || "",
    yearsOfExperience: initial?.yearsOfExperience ?? "",
  });
  const [saving, setSaving] = useState(false);
  const [err, setErr] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((s) => ({ ...s, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErr(null);
    setSaving(true);
    try {
      // Normalize yearsOfExperience to number-or-empty
      const values = {
        ...form,
        yearsOfExperience:
          form.yearsOfExperience === "" ? null : Number(form.yearsOfExperience),
      };
      await onSave(values);
    } catch (ex) {
      setErr(ex?.message || "Failed to save changes");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/40" onClick={onClose} />
      {/* Modal */}
      <div className="relative z-10 w-full max-w-2xl rounded-xl bg-white p-6 shadow-xl">
        <div className="mb-4 flex items-center justify-between">
          <h2 className="text-lg font-semibold text-gray-900">
            Edit Personal Information
          </h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700"
            aria-label="Close"
          >
            ✕
          </button>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <label className="block">
              <span className="text-sm text-gray-700">First Name</span>
              <input
                type="text"
                name="firstName"
                value={form.firstName}
                onChange={handleChange}
                className="mt-1 w-full rounded-md border px-3 py-2"
              />
            </label>
            <label className="block">
              <span className="text-sm text-gray-700">Last Name</span>
              <input
                type="text"
                name="lastName"
                value={form.lastName}
                onChange={handleChange}
                className="mt-1 w-full rounded-md border px-3 py-2"
              />
            </label>

            <label className="block">
              <span className="text-sm text-gray-700">Date of Birth</span>
              <input
                type="date"
                name="dateOfBirth"
                value={form.dateOfBirth}
                onChange={handleChange}
                className="mt-1 w-full rounded-md border px-3 py-2"
              />
            </label>
            <label className="block">
              <span className="text-sm text-gray-700">Email</span>
              <input
                type="email"
                name="email"
                value={form.email}
                onChange={handleChange}
                className="mt-1 w-full rounded-md border px-3 py-2"
              />
            </label>

            <label className="block">
              <span className="text-sm text-gray-700">Phone Number</span>
              <input
                type="text"
                name="phoneNumber"
                value={form.phoneNumber}
                onChange={handleChange}
                className="mt-1 w-full rounded-md border px-3 py-2"
              />
            </label>
            <label className="block">
              <span className="text-sm text-gray-700">Years of Experience</span>
              <input
                type="number"
                min="0"
                name="yearsOfExperience"
                value={form.yearsOfExperience}
                onChange={handleChange}
                className="mt-1 w-full rounded-md border px-3 py-2"
              />
            </label>

            <label className="block">
              <span className="text-sm text-gray-700">Gender</span>
              <select
                name="gender"
                value={form.gender}
                onChange={handleChange}
                className="mt-1 w-full rounded-md border px-3 py-2 bg-white"
              >
                <option value="">Select…</option>
                {GENDERS.map((g) => (
                  <option key={g} value={g}>
                    {g}
                  </option>
                ))}
              </select>
            </label>

            <label className="block">
              <span className="text-sm text-gray-700">Ethnicity</span>
              <select
                name="ethnicity"
                value={form.ethnicity}
                onChange={handleChange}
                className="mt-1 w-full rounded-md border px-3 py-2 bg-white"
              >
                <option value="">Select…</option>
                {ETHNICITIES.map((e) => (
                  <option key={e} value={e}>
                    {e}
                  </option>
                ))}
              </select>
            </label>
          </div>

          {err && <p className="text-sm text-red-600">{err}</p>}

          <div className="mt-4 flex justify-end gap-3">
            <button
              type="button"
              onClick={onClose}
              className="rounded border px-4 py-2 text-sm text-gray-700 hover:bg-gray-50"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={saving}
              className="rounded bg-emerald-600 px-4 py-2 text-sm text-white hover:bg-emerald-700 disabled:opacity-60"
            >
              {saving ? "Saving…" : "Save"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
